import { css } from '@emotion/react';

// eslint-disable-next-line import/prefer-default-export
var formMixin = function formMixin() {
  return /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:formMixin;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

// This is an example of how the formMixin may be used to
// style a form layout using grid.

// export const formMixin = ({ theme }) => css`
//   &.vio-vio-seo_referral_program-lc {
//     @media (min-width: ${theme.breakpoints.sm}) {
//       display: grid;
//       grid-gap: 10px;
//       grid-template-areas:
//         'first_name last_name'
//         'referral_name zip_postal'
//         'email_address email_address'
//         'referral_email referral_email'
//         'submit_button submit_button'
//         'form_disclaimer form_disclaimer';
//     }
//   }

//   &.vio-vio-footer_request-lc {
//     @media (min-width: ${theme.breakpoints.sm}) {
//       display: grid;
//       grid-gap: 10px;
//       grid-template-areas:
//         'first_name last_name'
//         'phone_number zip_postal'
//         'email_address email_address'
//         'looking_to_secure looking_to_secure'
//         'submit_button submit_button'
//         'form_disclaimer form_disclaimer';

//       .options_looking_to_secure {
//         display: grid;
//         grid-gap: 10px;
//         grid-template-areas: 'home business apartment';
//       }
//     }
//   }

//   &.vio-vio-megaform_request_quote-lc {
//     @media (min-width: ${theme.breakpoints.sm}) {
//       display: grid;
//       grid-gap: 10px;
//       &.step-1 {
//         grid-template-areas: 'radioButtons radioButtons';
//       }

//       &.step-2 {
//         grid-template-areas: 'radioButtons2 radioButtons2';
//       }

//       &.step-3 {
//         grid-template-areas: 'radioButtons3 radioButtons3';
//       }

//       &.step-4 {
//         grid-template-areas: 'radioButtons4 radioButtons4';
//       }

//       &.step-5 {
//         grid-template-areas:
//           'first_name last_name'
//           'zip_postal phone_number'
//           'email_address email_address'
//           'submit_button submit_button'
//           'form_disclaimer form_disclaimer';
//       }
//     }
//   }
// `

export { formMixin };
//# sourceMappingURL=formMixins.js.map
